import styled from "styled-components";

export const MainSection = styled.div`
width: 100%;
/* height: 650px; */
background-color: white;
padding-top: 50px;
padding-left: 100px;
display: flex;

@media only screen and (max-width: 560px) {
  display: inline-block;
  padding: 20px;
  
}
`;

export const CompanyOverviewAndCulture = styled.section`
flex: 1;
height: 45%;
width: 35%;
/* border: 1px solid black; */
color: black;
padding-right: 60px;

@media only screen and (max-width: 560px) {
  padding: 25px 0px 0px 0px;
  width: 100%;
  text-align: center;
}
 
.title{
   font-family: "Montserrat";
   font-weight: bold;
   padding-bottom: 10px;
 }

 .text-overview1 {
  font-family: "Helvetica";
  font-size: 15px;
  padding-bottom: 30px;

  /* &>span {
    font-weight: bold;
  } */
 }
`;

export const EmploymentOppAndBen = styled(CompanyOverviewAndCulture)`
padding-right: 0px;

 .text-overview1.bullet {
  margin-bottom: 5px; 
  padding-bottom: 0px;

  &.last {
    margin-bottom: 40px;
  }

 }

 .last {
     padding-bottom: 40px;
   }

`;

